<template>
    <div class="screen">
        <img class="bg"
            src="https://cdn.edstatic.com/203012120000/9930d6729be921f566a341f2c0ff4173/2025/07/bdd2a84a-5677-4a00-a423-07def21a682b.png"
            alt="">
        <div class="alert" v-if="showImgPopup && currentImg">
            <div class="content">
                <img :src="currentImg" />
                <div class="count-down">{{ countdown }}s</div>
            </div>
        </div>
        <div class="main">
            <swiper ref="mainSwiper" :options="swiperOption">
                <!-- 统一渲染所有轮播项 -->
                <swiper-slide v-for="(item, index) in swiperList" :key="`slide-${index}`"
                    :class="`slide-type-${item.type}`">
                    <!-- 视频类型 -->
                    <div v-if="item.type === 'video'" class="video-slide">
                        <video :ref="`videoPlayer${index}`" :src="item.video" controls="controls" class="video-content"
                            autoplay muted x5-video-player-type='h5' preload="auto" webkit-playsinline playsinline
                            @ended="handleVideoEnd(index)"></video>
                        <div class="title">
                            {{ item.title }}
                        </div>
                        <div class="qrcode">
                            <div class="qrcode-item">
                                <img :src="official_qrcode" alt="">
                                <p>官方公众号</p>
                            </div>
                            <div class="qrcode-item">
                                <img :src="meeting_qrcode" alt="">
                                <p>大会官网</p>
                            </div>
                        </div>
                    </div>

                    <!-- 海报类型 -->
                    <div v-else-if="item.type === 'poster'" class="poster-slide wrap">
                        <div class="banner">
                            <img :src="item.img" class="">
                            <div class="column" v-if="item.column_user">
                                <img class="cover" :src="item.column_user.head_img" alt="">
                                <div class="name">
                                    {{ item.column_user.user_name }}
                                </div>
                            </div>
                            <div class="title">
                                {{ item.title }}
                            </div>
                        </div>

                        <div class="detail">
                            <img class="logo-bg"
                                src="https://cdn.edstatic.com/203012120000/9251fd08fc90fb068ccefd10138544ed/2025/07/cef8a6bd-b1b0-4c6c-9b52-52f91ef5b1af.png"
                                alt="">
                            <div class="author" v-if="item.user">
                                <img class="avatar" :src="item.user.head_img" alt="">
                                <div class="info">
                                    <div class="name">
                                        <span>{{ item.user.user_name }}</span>
                                        <div>{{ item.user.tag }}</div>
                                    </div>
                                    <div class="hospital">{{ item.user.hospital_name }}</div>
                                </div>
                            </div>

                        </div>
                        <div class="bottom">
                            <div class="left">
                                <img src="https://cdn.edstatic.com/203012120000/4ecf46ccdc644808165ceff0bb433367/2025/07/72501abf-ed5c-4485-b840-09e9e14237df.png"
                                    alt="">
                                <p>扫描右侧二维码阅读更多</p>
                            </div>
                            <img class="right" :src="item.qrcode" alt="">
                        </div>
                    </div>

                    <!-- 访问量类型 -->
                    <div v-else-if="item.type === 'visit'" class="visit-slide">
                        <div class="top">
                            <img class="pic-1"
                                src="https://cdn.edstatic.com/203012120000/7405510ac5d54f955dd3c893b1a10754/2025/07/30ea1f73-96fe-4c3b-8aca-d36b66edda1d.png"
                                alt="">
                            <img class="pic-2"
                                src="https://cdn.edstatic.com/203012120000/9bd2a2efb43cce5637b5aae3c7698afc/2025/07/ee310b59-7d56-4c32-b77a-57361a748c25.png"
                                alt="">
                        </div>
                        <div class="main">
                            <div class="all-counts">访问人数 {{ meetingData }} 人 </div>
                            <ul class="list">
                                <li v-for="(num, j) in item.datas" :key="j">
                                    <p class="hall">{{ num.title.slice(0, 4) }}</p>
                                    <div class="flex1">
                                        <van-progress :percentage="(100 - j * 10)" :show-pivot="false"
                                            :stroke-width="20" :color="num.color" />
                                    </div>

                                    <!-- <div class="num">
                                        <img class="icon-fire" :src="num.icon" alt="">
                                        <span>{{ num.total }}</span>
                                    </div> -->
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- 图片类型 -->
                    <!-- <div v-else-if="item.type === 'image'" class="image-slide">
                        <img :src="item.image" class="image-content">
                    </div> -->

                </swiper-slide>
            </swiper>

        </div>

    </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { MeetingCarouselSwiper } from "../../config/interface.js";
export default {
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            meeting_id: this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id,
            videoList: [
                { url: 'https://vod.talkmed.com/4684025dvodcq1252020456/b40f98e13560136624739404364/JepyGVGQ8Y8A.mp4' },
                { url: 'https://vod.talkmed.com/4684025dvodcq1252020456/b40f98e13560136624739404364/JepyGVGQ8Y8A.mp4' }
            ],
            // 图片资源列表（保留原有数据）
            imageList: {},
            posterList: [
                { url: '//cdn.edstatic.com/203012120000/2102ba2a5337f7fe91883757938ae167/2025/07/f414ad12-c096-4727-83bd-b80b372597f4.png', }
            ],
            visitDataList: [],
            activeIndex: 0,
            videoCycleComplete: false,
            meeting_qrcode: '',
            official_qrcode: '',
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 60000,
                    disableOnInteraction: false
                },
                centeredSlides: true,
                updateOnWindowResize: true,
                resizeObserver: true,
                observer: true,
                observeParents: true,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1
                },
                speed: 600,
                watchSlidesProgress: true,
            },
            swiperList: [],
            meetingData: '',
            showImgPopup: false,
            countdown: 60,
            timer: null,
            currentImg: '',
            scheduleTime: ['2025-07-17 11:10:00', '2025-07-17 11:12:00', '2025-07-16 11:49:00', '2025-07-16 18:15:00']// 替换为实际的时间表时间

        };
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    mounted() {
        // 初始化数据加载
        [1, 2, 3, 4].forEach(type => this.getSwiperData(type));
        this.$nextTick(() => {
            const swiper = this.$refs.mainSwiper.swiper;
            if (!swiper) return;
            // 新增自动播放处理
            // 轮播切换事件处理
            swiper.on('slideChange', () => {
                const realIndex = swiper.realIndex;
                const currentItem = this.swiperList[realIndex];
                console.log(realIndex);
                // 处理视频播放
                if (currentItem.type === 'video') {
                    this.handleVideoSlide(realIndex, swiper);
                } else {
                    // 处理非视频播放
                    this.handleNonVideoSlide(realIndex, swiper);
                }
            });

        });

    },
    methods: {

        initSwiperList() {
            // 合并四种类型的轮播内容到统一列表
            this.swiperList = [
                ...this.videoList.map(item => ({ ...item, type: 'video' })),
                ...this.posterList.map(item => ({ ...item, type: 'poster' })),
                ...this.visitDataList.map(item => ({ ...item, type: 'visit' })),
                // ...this.imageList.map(item => ({ ...item, type: 'image' })),
            ];

            const swiper = this.$refs.mainSwiper.swiper;
            if (swiper.autoplay.running) {
                swiper.autoplay.stop();
            }
            this.$nextTick(() => {
                // 触发自动播放
                if (swiper && this.swiperList.length > 6) {
                    // this.startAutoPlay(swiper);
                    this.handleAutoPlay(swiper);

                }

            });

        },
        // 新增自动播放核心方法
        handleAutoPlay(swiper) {
            const realIndex = swiper.realIndex;
            const currentItem = this.swiperList[realIndex];
            if (currentItem.type === 'video') {
                console.log('currentItem', currentItem);

                const video = this.$refs[`videoPlayer${realIndex}`][0];
                if (video) {
                    // 尝试自动播放
                    const playPromise = video.play();

                    // 处理播放结果
                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                            // 自动播放成功
                            console.log('自动播放成功');
                        }).catch(error => {
                            // 自动播放失败，添加播放按钮覆盖层
                            this.addPlayButtonOverlay(video);
                            console.log('需要用户交互才能播放', error);
                        });
                    }
                }
            }
        },
        // 处理视频轮播项
        handleVideoSlide(index, swiper) {
            if (swiper.autoplay.running) {
                swiper.autoplay.stop();
            }
            const video = this.$refs[`videoPlayer${index}`][0];
            if (video) {
                // 清理旧监听器
                video.removeEventListener('ended', this.handleVideoEnd);
                // 添加新监听器
                video.addEventListener('ended', () => this.handleVideoEnd(index));
                // 保存当前视频引用
                this.currentVideo = video;
                // 播放视频
                video.currentTime = 0;
                // video.play()
                this.handleAutoPlay(swiper);

            }
        },
        // 处理非视频轮播项
        handleNonVideoSlide(index, swiper) {
            if (!swiper.autoplay.running) {
                swiper.autoplay.start();
            }
            // 停止当前视频播放
            if (this.currentVideo) {
                this.currentVideo.pause();
                this.currentVideo = null;
            }
            // console.log(index);
            if (index == this.swiperList.length - 1) {
                [1, 2, 3].forEach(type => this.getSwiperData(type));
                setTimeout(() => {
                    swiper.update(true); // 强制更新
                    swiper.slideTo(0, 0);
                }, 60000)
            }
            // 这里可以添加其他类型内容的处理逻辑
        },
        // 视频结束处理
        handleVideoEnd(currentIndex) {
            const swiper = this.$refs.mainSwiper.swiper;
            const nextIndex = currentIndex + 1;
            // console.log('VideoEnd', currentIndex)
            if (nextIndex < this.swiperList.length) {
                this.$nextTick(() => {
                    swiper.slideNext();
                });
            } else {
                // 所有内容播放完后循环播放
                this.$nextTick(() => {
                    swiper.slide(0, 0);
                });
            }
        },
        getSwiperData(type) {
            const url = MeetingCarouselSwiper;
            const method = 'Get';
            let params = {
                meeting_id: this.meeting_id,
                style_type: type
            };

            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        if (type == 1) {
                            this.videoList = res.data.videos || [];
                            // 保存二维码信息
                            this.meeting_qrcode = res.data.meeting_qrcode;
                            this.official_qrcode = res.data.official_qrcode;
                        } else if (type == 2) {
                            this.posterList = res.data || [];
                        } else if (type == 3) {
                            this.visitDataList = [{ 'datas': res.data.sessionData }] || [];
                            this.meetingData = res.data.meetingData
                        }
                        else if (type == 4 && res.data) {
                            this.imageList = res.data;
                            // if (this.meeting_id == 596) {
                            //     this.imageList = {
                            //         "2025-07-17 11:46:00"
                            //             :
                            //             "https://medmeeting.talkmed.com/image/schedule/2025.07.18/0750.jpeg",
                            //         "2025-07-17 11:52:00"
                            //             :
                            //             "https://medmeeting.talkmed.com/image/schedule/2025.07.19/1220.jpeg",
                            //         "2025-07-17 11:54:00"
                            //             :
                            //             "https://medmeeting.talkmed.com/image/schedule/2025.07.19/1220.jpeg",
                            //         "2025-07-17 11:56:00"
                            //             :
                            //             "https://medmeeting.talkmed.com/image/schedule/2025.07.19/1220.jpeg",
                            //     }
                            // }

                            this.scheduleTime = Object.keys(this.imageList)
                            console.log(this.scheduleTime)
                            this.checkScheduleTime()
                        }
                        // 更新所有数据后重新初始化轮播列表
                        this.initSwiperList();

                    }
                });

        },
        // 新增自动播放方法
        startAutoPlay(swiper) {
            const realIndex = swiper.realIndex;
            const currentItem = this.swiperList[realIndex];

            if (currentItem.type === 'video') {
                const video = this.$refs[`videoPlayer0`][0];
                if (video) {
                    video.play().catch(() => {
                        // 兼容移动端需要用户交互的限制
                        this.addPlayButtonOverlay(video);
                    });
                }
            }
        },
        // 新增播放按钮覆盖层（移动端兼容）
        addPlayButtonOverlay(video) {
            // 创建播放按钮元素
            const playBtn = document.createElement('div');
            playBtn.className = 'mobile-play-button';
            playBtn.innerHTML = '<i class="icon-play"></i>';
            playBtn.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10;
            cursor: pointer;
            opacity: 0;
        `;

            // 添加播放事件
            playBtn.addEventListener('click', () => {
                video.play();
                console.log('playBtn,click', '')
                playBtn.remove();
            });

            // 插入到视频元素
            video.parentNode.appendChild(playBtn);
            // playBtn.click()
        },
        checkScheduleTime() {
            const now = new Date()
            this.scheduleTime.forEach(scheduleStr => {
                const scheduleTime = new Date(scheduleStr)
                const diff = scheduleTime - now
                if (diff > 0) {
                    setTimeout(() => {
                        this.currentImg = this.imageList[scheduleStr]
                        console.log(this.currentImg)
                        this.showPopup()
                    }, diff)
                } else if (diff <= 0 && diff > -1000 * 60) { // 如果当前时间在预定时间后1分钟内也触发
                    this.currentImg = this.imageList[scheduleStr]
                    this.showPopup()
                }
            })

        },
        showPopup() {
            this.showImgPopup = true
            this.startCountdown()
        },
        startCountdown() {
            this.timer = setInterval(() => {
                this.countdown--
                if (this.countdown <= 0) {
                    this.closePopup()
                }
            }, 1000)
        },
        closePopup() {
            this.showImgPopup = false
            this.countdown = 60
            this.currentImg = ''
            clearInterval(this.timer)
        }
    }
};

</script>

<style lang="scss" scoped>
.screen {
    width: 100%;
    min-height: 100vh;
    height: 100%;
    position: relative;

    .bg {
        width: 100%;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
    }

    .main {
        width: 100%;
        position: relative;
        margin: auto;
        z-index: 2;
    }
}

.swiper-slide {
    width: 100%;
    height: 100%;
    min-height: 100vh;
}

.video-slide {
    width: 90%;
    animation: videoFadeIn 0.3s ease-out;
    position: relative;
    margin: 0 auto;
    margin-top: 15vh;

    .title {
        margin: 4%;
        font-size: 0.5rem;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        height: 1.4rem;
        line-height: 0.7rem;
    }

    .qrcode {
        display: flex;
        width: 100%;
        justify-content: center;
        padding: 0 5%;
        margin-top: 10%;

        .qrcode-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 10px;
            flex: 1;

            img {
                width: 70%;
                border: 2px solid #B2E2F9;
                border-radius: 0.2rem;
                overflow: hidden;

            }

            p {
                font-size: 0.5rem;
                color: #161616;
            }
        }

    }
}

@keyframes videoFadeIn {
    from {
        opacity: 0;
        transform: scale(0.95);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

.video-content {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: #000;
    border-radius: 5px;
    overflow: hidden;
}

.image-slide {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 6;
    height: 100%;
    min-height: 100vh;
    width: 100%;
}

.image-content {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.poster-slide {
    width: 74%;
    height: 100%;
    margin: 0 auto;
    margin-top: 11vh;
    min-height: 70vh;
    background: linear-gradient(176deg, #DBE6FE -26%, #F8FBFF 98%);
    border-radius: 10px;
    padding: 8% 0% 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .banner {
        position: relative;
        border-radius: 5px;
        overflow: hidden;
        display: flex;
        padding: 0 5%;

        img {
            width: 100%;
            height: auto;
        }
    }

    .banner::after {
        content: '';
        position: absolute;
        bottom: 0px;
        left: 5%;
        display: block;
        height: 40%;
        background: linear-gradient(0deg, rgba(0, 0, 0, .7), transparent);
        width: 90%;
    }

    .column {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 3;
        display: flex;
        gap: 10px;
        align-items: center;
        padding: 0 5%;

        .cover {
            width: 0.8rem;
            height: 0.8rem;
            border-radius: 50%;
            background: #fff;
        }

        .name {
            color: #fff;
            font-size: 0.5rem;
            text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
        }

    }

    .title {
        position: absolute;
        z-index: 3;
        margin: 5%;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        color: #fff;
        font-size: 0.5rem;
        bottom: 0;
        width: 80%;
    }

    .detail {
        position: relative;
        padding: 5%;

        .logo-bg {
            width: 50%;
            position: absolute;
            right: 0;
            top: 0;

        }

        .author {
            display: flex;
            align-content: center;
            gap: 10px;

            .avatar {
                width: 1.3rem;
                height: 1.3rem;
                border-radius: 50%;
                background: #fff;
                object-fit: cover;
            }

            .info {

                .name {
                    color: #333;
                    display: flex;
                    gap: 10px;
                    align-items: center;
                    margin-bottom: 3px;
                    font-size: 0.4rem;

                    div {
                        padding: 0px 10px;
                        background: #C4D8FD;
                        font-size: 0.34rem;
                        border-radius: 4px;
                        color: #2250A3;
                    }
                }

                .hospital {
                    font-size: 0.4rem;
                    color: #666;
                }

            }
        }
    }

    .bottom {
        width: 100%;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        z-index: 4;
        margin-top: 40px;
        flex: 1;
        padding: 5%;

        .left {
            flex: 1;

            img {
                width: 50%;
            }

            p {
                color: #999;
                font-size: 0.4rem;
            }
        }

        .right {
            width: 30%;
        }
    }
}

img {
    max-width: 100%;
}

.visit-slide {
    position: relative;
    width: 90%;
    margin: 0 auto;
    margin-top: 16vh;
    min-height: 70vh;
    overflow: hidden;

    .top {
        display: flex;
        flex-direction: column;
        align-items: center;

        .pic-1 {
            width: 90%;
            height: auto;
        }

        .pic-2 {
            width: 70%;
            height: auto;
            margin: 0.4rem 0 0;
            display: block;
        }
    }

    .main {
        width: 88%;
        backdrop-filter: blur(0.2rem);
        // box-shadow: 0px 62px 107px 0px rgba(49, 78, 96, 0.2), inset 0px 21px 43px 0px #FFFFFF;
        background: linear-gradient(180deg, rgba(234, 247, 255, 0.3) 0%, rgba(218, 241, 255, 0.3) 100%);
        border: 2px solid #CFEEFF;
        min-height: 50vh;
        // border-image: linear-gradient(216deg, #CFEEFF 1%, #53ADEC 97%) 10;
        border-radius: 0.5rem;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 4vh;
        padding-bottom: 0.6rem;

        .all-counts {
            width: 85%;
            height: 1.2rem;
            line-height: 1.2rem;
            background: linear-gradient(180deg, #66BEFF 0%, #006FBD 100%);
            border-radius: 1rem;
            text-align: center;
            color: #fff;
            font-weight: 600;
            font-size: 0.5rem;
            margin: 0.6rem auto;
        }

        .list {
            display: flex;
            flex-direction: column;
            gap: 0.6rem;
            width: 88%;

            li {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 0.2rem;

                .flex1 {
                    flex: 1;
                    overflow: hidden;
                }

                .hall {
                    font-size: 0.5rem;
                    font-weight: 500;
                    width: 2rem;
                    flex-shrink: 0;
                    overflow: hidden;
                    white-space: nowrap;
                }

                .num {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    flex-shrink: 0;
                    width: 1rem;
                    font-size: 0.4rem;

                    img {
                        width: 0.4rem;

                    }
                }
            }
        }
    }
}

.van-progress {
    border-radius: 20px !important;
    height: 20px;
    max-width: 100%;
    overflow: hidden;
}

@media screen and (max-width:500px) {
    .video-slide .title {
        font-size: 0.35rem;
        line-height: 0.5rem;
        height: 1rem;
    }

    .video-slide .qrcode .qrcode-item p {
        font-size: 0.35rem;
    }

    .poster-slide .title {
        font-size: 0.35rem;
    }

    .poster-slide {
        .avatar {
            width: 1rem !important;
            height: 1rem !important;
        }

        .name {
            font-size: 0.3rem !important;

            div {
                font-size: 0.3rem !important;
            }
        }

        .hospital {
            font-size: 0.3rem !important;
        }


        .bottom .left p {
            font-size: 0.35rem;
        }

    }

    .visit-slide {
        .top {
            width: 96%;
            margin: 0 auto;
        }

        .main {
            width: 82%;

            .list {
                gap: 10px;
            }

            .hall {
                font-size: 0.35rem !important;
                width: 1.4rem !important;
            }

            .num {
                font-size: 0.3rem !important;
            }

            .all-counts {
                font-size: 0.4rem;
                height: 0.9rem;
                line-height: 0.9rem;
            }
        }
    }

    .van-progress {
        border-radius: 10px !important;
        height: 10px !important;

    }
}

.alert {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;

    .content {
        width: 80%;
        margin: 0 auto;
        position: relative;
    }

    .count-down {
        width: 60px;
        line-height: 24px;
        height: 24px;
        color: #fff;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 20px;
        position: absolute;
        right: 30px;
        bottom: 20px;
        text-align: center;
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/SwiperPoster/index.vue